import { createCustomToggle, customCountdown, customSearchItem } from './helpers';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  createCustomToggle();
  customSearchItem();
  customCountdown();
});
